module.exports = __webpack_public_path__ + "static/media/alexandria2.cfb926be.png";